import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PhoneCodeCountryList from '../../types/PhoneCodeCountryList';
import { hasSubstr } from '../../utils';
import SelectItem from '../SelectItem';
import Select from '../Select';
import SelectSearch from '../SelectSearch';
import styles from './PhoneCodeDropdown.module.css';
const PhoneCodeDropdown = ({ selectedPhoneCode, onSelect }) => {
    const [search, setSearch] = useState('');
    const searchChange = (e) => {
        setSearch(e.currentTarget.value);
    };
    const listedCountryPhoneCodes = PhoneCodeCountryList.filter((metadata) => {
        // @ts-ignore
        const country = metadata[0];
        // @ts-ignore
        const phoneCode = metadata[3];
        if (!isNaN(+search)) {
            return hasSubstr(phoneCode.toString(), search);
        }
        if (search.length <= 2)
            return true;
        return hasSubstr(country, search);
    });
    return (_jsx("div", Object.assign({ className: styles.root }, { children: _jsxs(Select, Object.assign({ onClick: () => setSearch(''), title: `+${selectedPhoneCode}`, value: selectedPhoneCode, size: "small" }, { children: [_jsx(SelectSearch, { onChange: searchChange, value: search, error: listedCountryPhoneCodes.length === 0 }, void 0), listedCountryPhoneCodes.map((metadata) => {
                    const country = metadata[0];
                    // @ts-ignore
                    const phoneCode = metadata[3];
                    return (_jsx(SelectItem, Object.assign({ onSelect: () => onSelect(phoneCode), isSelected: Number(selectedPhoneCode) === Number(phoneCode) }, { children: `${country} +${phoneCode}` }), `${country}${phoneCode}`));
                })] }), void 0) }), void 0));
};
export default PhoneCodeDropdown;
